import React from "react";
import { useInspections } from "../../domains/inspections/useInspections";
import GradeScale from "./stats/GradeScale";
import InfoTip from "../InfoTip";

function Summary({ text }) {
  return (
    <p className="ds-hint ds-ofsted-summary">
      <span className="v2-info-tip--label">
        <span className="ds-ofsted-summary-text">{text}</span>
        <InfoTip text={text} label="Full Ofsted summary" />
      </span>
    </p>
  );
}

function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-GB", { year: "numeric", month: "short", day: "numeric" });
}

export default function InspectionsPanel({ schoolId, enabled }) {
  const { rows, loading, error } = useInspections(schoolId, Boolean(enabled && schoolId));

  if (!enabled) return null;

  if (loading) {
    return (
      <div className="v2-catchment-panel">
        <div className="v2-muted">Loading inspections…</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="v2-catchment-panel">
        <div className="v2-muted" style={{ color: "#c00" }}>
          {error}
        </div>
      </div>
    );
  }

  if (!rows?.length) {
    return (
      <div className="v2-catchment-panel">
        <div className="v2-muted">No inspection rows in data yet.</div>
      </div>
    );
  }

  return (
    <div className="v2-catchment-panel v2-inspections-panel">
      {rows.map((r) => {
        const bits = [];
        const date = fmtDate(r.inspection_date);
        if (date) bits.push(date);
        if (!r.overall_grade) bits.push("No single overall grade");
        if (r.report_url) {
          bits.push(
            <a key="report" className="v2-drawer-link" href={r.report_url} target="_blank" rel="noreferrer">
              Report →
            </a>
          );
        }
        if (r.establishment_url) {
          bits.push(
            <a key="gov" className="v2-drawer-link" href={r.establishment_url} target="_blank" rel="noreferrer">
              Gov.uk →
            </a>
          );
        }
        return (
          <div key={r.id} className="v2-inspection-card">
            <GradeScale grade={r.overall_grade} />
            {bits.length ? (
              <p className="ds-hint ds-ofsted-meta">
                {bits.map((bit, index) => (
                  <React.Fragment key={index}>
                    {index > 0 ? " · " : null}
                    {bit}
                  </React.Fragment>
                ))}
              </p>
            ) : null}
            {r.summary ? <Summary text={r.summary} /> : null}
          </div>
        );
      })}
      <p className="ds-hint ds-ofsted-meta">Ofsted. Read the report.</p>
    </div>
  );
}
